export default {"src":"/_next/static/media/pr.d607ad4b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};